export default __webpack_public_path__ + "static/media/seat.c8e07262.png";